import { Link } from "react-router-dom";
import { money } from "@/lib/callStats";

export default function MonthlyGoalPanel({ snapshot, symbol = "$", compact = false }) {
  const pct = Math.min(100, Math.max(0, snapshot.progressPct || 0));
  const pctLabel = (snapshot.progressPct || 0).toLocaleString(undefined, {
    minimumFractionDigits: 1,
    maximumFractionDigits: 1,
  });
  const todayHit = snapshot.dailyTarget > 0 && snapshot.todayEarnings >= snapshot.dailyTarget - 0.005;

  return (
    <div className={`mpd-goal-panel ${compact ? "is-compact" : ""}`}>
      <p className="mpd-goal-amt">
        {money(snapshot.goal, symbol)}
        <span>Monthly goal · {snapshot.monthLabel}</span>
      </p>
      <div className="mpd-goal-progress">
        <div className="mpd-bar mpd-bar-lg">
          <span style={{ width: `${pct}%` }} />
        </div>
        <strong>{pctLabel}%</strong>
      </div>
      <div className="mpd-goal-grid">
        <div>
          <span>Est. earned</span>
          <strong>{money(snapshot.earned, symbol)}</strong>
        </div>
        <div>
          <span>Remaining</span>
          <strong>{money(snapshot.remaining, symbol)}</strong>
        </div>
        <div>
          <span>Daily pace</span>
          <strong>
            {snapshot.remainingDays > 0 ? `${money(snapshot.dailyTarget, symbol)}/day` : "—"}
          </strong>
        </div>
        {snapshot.remainingDays > 0 ? (
          <div>
            <span>Today vs pace</span>
            <strong className={todayHit ? "is-up" : "is-down"}>
              {money(snapshot.todayEarnings, symbol)} / {money(snapshot.dailyTarget, symbol)}
            </strong>
          </div>
        ) : (
          <div>
            <span>Target</span>
            <strong className={snapshot.reached ? "is-up" : "is-down"}>
              {snapshot.reached ? "Reached" : "Not reached"}
            </strong>
          </div>
        )}
      </div>
      {compact ? (
        <p className="mpd-muted">
          <Link to="/goals">Edit goal</Link>
        </p>
      ) : (
        <p className="mpd-muted">{snapshot.hint}</p>
      )}
    </div>
  );
}
